import CompareField from "@/components/Form/Fields/CompareField";
import FormFieldValues from "@/components/Form/Fields/FormFieldValues";
import { FV } from "@/components/Form/Validation/FormValidators";
import { PDFHighlight } from "@/components/PDFViewer/PDFViewer";
import i18n from "@/i18n";
import BFChooserSelect from "@/modules/abstract-ui/forms/chooser/BFChooserSelect";
import BFInput from "@/modules/abstract-ui/forms/input/BFInput";
import StringUtils from "@/utils/StringUtils";
import classNames from "classnames";
import { FormApi } from "final-form";
import { Invoice, InvoiceKind } from "../../../RAInterfaces";
import { getAvailableDunningLevels } from "../../../RAUtils";
// import "./RAInvoiceDunningPaymentFields.scss";

interface RAInvoiceDunningPaymentFieldsProps {
  disableAll?: boolean;
  ignoreCompare?: boolean;
  prefix?: string;
  invoice: Invoice;
  form: FormApi;
  onHighlight: (highlight?: PDFHighlight | PDFHighlight[]) => void;

  uploadForm?: boolean;
  invoiceKind: InvoiceKind;
}
const RAInvoiceDunningPaymentFields = (
  props: RAInvoiceDunningPaymentFieldsProps
) => {
  return (
    <div className={classNames("form-row")}>
      <div className={`__field __flex-1`}>
        <FormFieldValues names={[`${props.prefix || ""}currency`]}>
          {([currency]) => (
            <CompareField
              ignoreCompare={props.ignoreCompare}
              name={`${props.prefix || ""}dunningValue`}
              validate={FV.compose(FV.required())}
            >
              {({ input, meta }) => (
                <BFInput
                  type={"priceInput"}
                  disabled={props.disableAll}
                  {...input}
                  {...FV.getValidation(meta)}
                  suffix={StringUtils.getCurrencySymbol(currency)}
                  textAlign="right"
                  label={
                    i18n.t(
                      "ra:RAInvoiceDunningPaymentFields.dunningValue",
                      "Verzugskosten"
                    ) + "*"
                  }
                />
              )}
            </CompareField>
          )}
        </FormFieldValues>
      </div>
      <div className={`__field __flex-1`}>
        <CompareField
          ignoreCompare={props.ignoreCompare}
          name={`${props.prefix || ""}dunningLevel`}
          validate={FV.compose(FV.required())}
          initialValue={1}
        >
          {({ input, meta }) => (
            <BFChooserSelect
              disabled={props.disableAll}
              {...input}
              {...FV.getValidation(meta)}
              label={
                i18n.t(
                  "ra:RAInvoiceDunningPaymentFields.dunningLevel",
                  "Mahnstufe"
                ) + "*"
              }
              data={getAvailableDunningLevels()}
            />
          )}
        </CompareField>
      </div>
    </div>
  );
};

export default RAInvoiceDunningPaymentFields;
